import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Card, Skeleton } from "@mui/material";
import PropTypes from "prop-types";

const columns = [
  {
    flex: 1,
    field: "make",
    headerName: "Make",
    valueGetter: (params) => params.row.make,
  },
  {
    flex: 1,
    field: "linkAddress",
    headerName: "Link Address",
    valueGetter: (params) => params.row.linkAddress,
  },

  {
    flex: 1,
    field: "linkText",
    headerName: "Link Text",
    valueGetter: (params) => params.row.linkText,
  },

  {
    flex: 1,
    field: "modelsText",
    headerName: "modelsText",
    valueGetter: (params) => params.row.modelsText,
  },

  {
    flex: 1,
    field: "offerText",
    headerName: "offerText",
    valueGetter: (params) => params.row.offerText,
  },

  {
    flex: 1,
    field: "offerTitle",
    headerName: "offerTitle",
    valueGetter: (params) => params.row.offerTitle,
  },

  {
    flex: 1,
    field: "view",
    headerName: "View",
    sortable: false,
    minWidth: 90,
    headerAlign: "center",
    align: "center",
    // flex: 1,
    disableClickEventBubbling: true,
    renderCell: () => {
      return <Button variant="outlined">View</Button>;
    },
  },
];

const OfferListing = ({
  isLoading,
  error,
  data,
  rowCountState,
  paginationModel,
  setPaginationModel,
  handleSelectCar,
}) => {
  function handleCellClick(params) {
    console.log(params);

    if (params.field === "view") {
      handleSelectCar(params.row);
    }
  }

  if (isLoading) {
    return (
      <Skeleton
        sx={{
          transform: "scale(1, 1.0)",
          transformOrigin: "0% 0%",
        }}
        width="100%"
        height="600px"
      />
    );
  }

  if (error) {
    return <p>Something went wrong</p>;
  }

  return (
    <Card sx={{ p: 2 }}>
      <Box sx={{ height: 600, width: "100%" }}>
        <DataGrid
          // sx={{ width: "100%", overflowX: "scroll" }}
          rows={data?.offerTrackerList}
          columns={columns}
          rowCount={rowCountState}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          loading={isLoading}
          paginationMode="server"
          onCellClick={handleCellClick}
        />
      </Box>
    </Card>
  );
};

export default OfferListing;

OfferListing.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.any,
  data: PropTypes.shape({
    offerTrackerList: PropTypes.arrayOf(
      PropTypes.shape({
        make: PropTypes.string,
        linkAddress: PropTypes.string,
        linkText: PropTypes.string,
        modelsText: PropTypes.string,
        offer: PropTypes.string,
        offerText: PropTypes.string,
        offerTitle: PropTypes.string,
      })
    ),
  }),
  rowCountState: PropTypes.number,
  paginationModel: PropTypes.shape({
    pageSize: PropTypes.number,
    page: PropTypes.number,
  }),
  setPaginationModel: PropTypes.func,
};
